import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    formatSDCardRequest,
    clearRedux,
} from 'Redux/actions';

const VIDFLEET_ERROR_CODES = {
    23: "common_authentication_failed",
    24: "",
    200: "common_camera_password_error",
    201: "common_camera_operation_failed",
    202: "common_camera_does_not_exist",
    204: "common_sync_camera_error",
    209: "common_camera_does_not_exist",
}

const FormatSDCard = (props) => {
    const { device } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const { loading, openModal, result } = useSelector(state => state.formatSDCardRedux);

    const closeModal = () => {
        dispatch(clearRedux("FORMAT_SD_CARD"));
    }

    const confirmFormat = () => {
        dispatch(formatSDCardRequest({ esn: device?.esn, id: device?.id }));
    }

    useEffect(() => {
        if (result && !result?.error) {
            if (result?.result?.cmdID) {
                NotificationManager.success(
                    messages['format_sd_card_command_sent_to_the_device'],
                    messages['format_sd_card_title'],
                    3000
                );
                closeModal();
            } else {
                NotificationManager.error(
                    messages['reboot_device_sending_command_not_accepted'],
                    messages['format_sd_card_title'],
                    3000
                );
            }
        } else if (result?.error) {
            let message = messages['format_sd_card_error_sending_the_command'];
            if (result.error && result.error.code) {
                let messageKey = VIDFLEET_ERROR_CODES[result.error.code]
                if (!messageKey && messageKey !== "") {
                    message = messages[messageKey];
                } else {
                    message = result.error.msg
                }
            }
            //Error message
            NotificationManager.error(
                message,
                messages['format_sd_card_title'],
                3000
            );
            closeModal();
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={messages['format_sd_card_title']}
            loading={loading}
            position="right"
            size="small"
            handleClose={closeModal}
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <label style={{ marginBottom: 5 }}>
                        {messages['format_sd_card_label']}
                    </label>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => confirmFormat()}
                >
                    {messages['format_sd_card_format_sd_card']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default FormatSDCard;